import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  return (
    <div className="page">
      <div className="card">
        <p className="eyebrow">Errore 404</p>
        <h1>Pagina non trovata</h1>
        <p>
          La sezione richiesta non esiste ancora nell&apos;area Admin. Torna alla{' '}
          <Link to="/">dashboard principale</Link> o scegli una delle voci disponibili
          dalla barra laterale.
        </p>
      </div>
    </div>
  )
}
